import { createSelector } from 'reselect';
import moment from 'moment';
import { fromJS } from 'immutable';

const baseSelector = state => state.subscriptions;

export const subscriptionSelector = createSelector(
    baseSelector,
    subscriptions => {
        return subscriptions
            .get('items')
            .valueSeq()
            .map(subscription =>
                fromJS({
                    id: subscription.get('id'),
                    activationDateString: formatDate(
                        subscription.get('activated_at'),
                        'nicht aktiviert'
                    ),
                    activationDate: formatDate(subscription.get('activated_at')),
                    activationCode: subscription.get('access_token'),
                    subscriptionName: formatText(subscription.get('subscription_name'), '-'),
                    email: subscription.get('email'),
                    startDate: subscription.get('start_date'),
                    startDateString: formatDate(subscription.get('start_date')),
                    endDate: subscription.get('end_date'),
                    endDateString: formatDate(subscription.get('end_date')),
                    activationDeviceId: subscription.get('device_id'),
                    activationOs: formatText(subscription.get('activation_os'), '-'),
                    contractId: subscription.get('contract_id'),
                    selected: subscription.getIn(['selected'], false),
                })
            )
            .sortBy(sub => sub.get('startDate'))
            .reverse();
    }
);

const formatText = (text, altText) => {
    if (text !== null && text !== undefined && text !== '') {
        return text;
    } else {
        return altText;
    }
};

const formatDate = (date, altText = '-') => {
    if (date !== null && date !== undefined) {
        return moment(date).format('LL');
    } else {
        return altText;
    }
};
